export default __webpack_public_path__ + "static/media/square-dashed.be9b8ba6.svg";